export { default as PageNotFound } from './app-404/PageNotFound.vue';
export { default as Footer } from './footer/Footer.vue';
export { default as HeaderPersonal } from './header_personal/HeaderPersonal.vue';
export { default as HeaderMain } from './header_main/HeaderMain.vue';
